import { render, staticRenderFns } from "./myText.vue?vue&type=template&id=4e0cace4&scoped=true&"
import script from "./myText.vue?vue&type=script&lang=js&"
export * from "./myText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0cace4",
  null
  
)

export default component.exports